import * as React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { FaSquareCheck } from 'react-icons/fa6';
import { cn } from '@/lib/utils';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & { checkboxType?: 'round' | 'square' }
>(({ className, checkboxType = 'round', ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 items-center shrink-0 border border-shade-light-default ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-text-sm font-medium border-dashed data-[state=checked]:border-none',
      checkboxType === 'square' ? 'rounded-1 border-solid border-2 border-[#C5D3D3]' : 'rounded-full',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current h-full w-full')}>
      {checkboxType === 'square' ? (
        <FaSquareCheck className="text-secondary-dark-default h-full w-full" />
      ) : (
        <FaCheckCircle className="text-secondary-dark-default h-full w-full" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
